import { NpsTag } from '@outdoorly/chat-sdk';

export const CONFIG_DEFAULTS = {
  labels: {
    searchingForExpert: 'Looking for an expert...',
    unreadMessages: 'Unread messages',
    chatPlaceholder: 'Type a message...',
    submitIntroMessage: 'Submit',
    howCanTheExpertHelp:
      'What do you need help with? Please be as descriptive as possible as it helps us match you with the right expert.',
    skipIntroMessage: 'Cancel',
    emailPlaceholder: 'Email',
    greetingDetail: 'We are a community of {{brandName}} loving super experts who are here to assist you.',
    customerSupport: 'Looking for customer service instead?',
    invalidEmail: 'Please enter a valid email address',
    whatIsYourEmail: "What's your email address?",
    skipEmail: 'Maybe later >>',
    matchingYouWithExpertWithName: "Thanks, {{firstName}}! We'll pair you now.",
    matchingYouWithExpertWithoutName: "Thanks! We'll pair you now.",
    matchedWithExpert: 'Matched with {{expertName}}',
    chattingWithPersona: "You're chatting with {{expertName}}'s assistant",
    matchedWithExpertPersona: "Matched with {{expertName}}'s assistant",
    answerIsAiGenerated: 'Assisted Answer',
    matchingWithExpert: "We're finding a {{brandName}} expert for you now.",
    waitMessage: 'This typically takes a few minutes.',
    conversationClosed: 'Chat closed',
    viewExpertProfile: 'View full profile',
    backToConversation: 'Back to chat',
    noExpertsAvailable: 'No experts are available.',
    sorryNoExperts:
      "Sorry we're having trouble connecting you. It seems like no experts are available right now.",
    youCanLeaveYourEmail:
      "So our {{brandName}} experts can respond, please give us a way to notify you. When they respond, you'll be notified here and by email.",
    doYouWantToAdd:
      "We'll send this info to a {{brandName}} expert to help. Is there anything else you'd like to add to your message? Remember, you may be away when they respond, so please be as descriptive as possible.",
    skipSecondEmailCollection: "I don't want to be notified >>",
    rateYourConversation: 'How would you rate your conversation?',
    selectReaction: 'Select your reaction',
    badRating: 'Poor',
    okayRating: 'Okay',
    goodRating: 'Great',
    cancelNPSButton: 'Cancel',
    submitReview: 'Submit Review',
    anythingToAddNPS: 'Anything else to add?',
    anythingToAddNPSPlaceholder: 'Add additional details here',
    whatWentWell: 'What went well?',
    whatWentOkay: 'What went okay?',
    whatWentPoorly: 'What went poorly?',
    howWasYourConvo: 'How was your conversation with {{expertName}}?',
    youRatedThisConvo: 'You rated your conversation with {{expertName}} as "{{rating}}"',
    editReview: 'Edit Review',
    skipNPS: 'Skip for now >>',
    aiChatTransferToastTitle: "You've hit the limit of our AI!",
    aiChatTransferToastMessage:
      'Thanks for testing our AI-based expert chat. We are transferring you to a human expert who will take over from here.',
    aiChatTransferInlineMessage:
      'Thanks for testing our AI-based expert chat. You’re now chatting with a real human expert who will take over.',
    NPSResponseLabels: {
      [NpsTag.ChattingToolEasyToUse]: 'Easy to use',
      [NpsTag.Condescending]: 'Condescending',
      [NpsTag.DidntConsiderBudget]: "Didn't consider budget",
      [NpsTag.DidntGetEnoughInformation]: 'Not enough information',
      [NpsTag.DidntHaveWhatIWasLookingFor]: "Didn't have desired item",
      [NpsTag.DidntLikeProduct]: "Didn't like the product",
      [NpsTag.ExpertListened]: 'Listened',
      [NpsTag.ExpertNotKnowledgeable]: "Wasn't knowledgeable",
      [NpsTag.ExpertWasKnowledgeable]: 'Knowledgeable',
      [NpsTag.Friendly]: 'Friendly',
      [NpsTag.Impersonal]: 'Impersonal',
      [NpsTag.IrrelevantRecommendations]: 'Irrelevant recommendation',
      [NpsTag.Pushy]: 'Pushy',
      [NpsTag.QualityRecommendations]: 'Quality recommendation',
      [NpsTag.RespondedQuickly]: 'Fast response',
      [NpsTag.Unprofessional]: 'Unprofessional',
      [NpsTag.WaitedTooLong]: 'Waited too long',
      [NpsTag.RespondedSlowly]: 'Responded too slowly'
    },
    needHelpPicking: "Need help picking? We're real product experts.",
    needHelpPickingSingleExpert: "I'm {{expertName}}, a {{brandName}} expert.",
    chatWithExpert: 'Connect with an expert',
    chatWithExpertActivator: 'Let us know if you need help picking the right products.',
    chatWithExpertActivatorSingleExpert: 'I can help you pick the right products.',
    vettedExpert: 'Vetted Expert',
    vettedExperts: 'Vetted Experts',
    closeActivator: 'Close',
    idleWarningExpertAbandon:
      'Unfortunately, we haven’t heard from your expert in a bit. We will auto-close the chat shortly.',
    idleWarningCustomerAbandon:
      'We haven’t heard from you in a bit. Send a message to keep the chat active, otherwise it will auto-close in:',
    whatsYourName: "👋 What's your name?",
    firstNamePlaceholder: 'First Name',
    firstNameSkip: "I don't have a first name",
    firstNameSubmit: 'Next',
    introToPII: 'We have a few questions before we pair you with an expert.',
    of: 'of',
    whatsYourEmailWithName: "📧 Hi {{firstName}}! What's your email?",
    whatsYourEmailWithoutName: "📧 Hi! What's your email?",
    emailSubmissionIntro: "Let's get chatting",
    emailSubmissionIntroSkip: 'Continue without an email',
    customerServicePromptButton: 'Go to Customer Support',
    continueAfterPrompting: 'Yes, I do need help from a product expert',
    continueToChatPrompt:
      'Are you sure you would like to speak with one of our {{brandName}} experts? These experts are not customer service agents, and cannot help with issues such as returns, warranties, shipping, or locating replacement parts.'
  },
  show: true
};

export const EXPERT_IMAGES = [
  'https://images.unsplash.com/photo-1519160558534-579f5106e43f',
  'https://images.unsplash.com/photo-1529675804080-e12a8d5cef9b',
  'https://images.unsplash.com/photo-1602192509154-0b900ee1f851',
  'https://images.unsplash.com/photo-1534680005367-f383c6f09a0d',
  'https://images.unsplash.com/photo-1600356604219-84058a7b2bce',
  'https://images.unsplash.com/photo-1652475422909-256dda88b12b',
  'https://images.unsplash.com/photo-1584223719571-778f3f37aa56',
  'https://images.unsplash.com/photo-1505866535066-ccebd6b2b98a'
];

export const DESKTOP_MEDIA_QUERY = '(min-width: 480px)';

export const INTRO_WARNING_WORDS = [
  'support',
  'customer',
  'service',
  'discount',
  'sale',
  'promo',
  'code',
  'return',
  'exchange',
  'warranty',
  'break',
  'broke',
  'fix',
  'replace',
  'parts',
  'repair',
  'crack',
  'snap',
  'stock',
  'ship',
  'subscribe',
  'newsletter',
  'email',
  'payment',
  'date',
  'available',
  'lost',
  'delay',
  'paying',
  'paypal',
  'credit',
  'card',
  'refused',
  'order',
  'status',
  'tracking',
  'receipt',
  'invoice',
  'cancel',
  'account',
  'login',
  'connect',
  'password',
  'username',
  'used',
  'value',
  'craigslist',
  'ebay',
  'marketing',
  'partnership',
  'sponsor',
  'influencer',
  'athlete',
  'prodeal',
  'pro-deal',
  'repair',
  'resole',
  'australia',
  'uk',
  'united kingdom',
  'europe',
  'international'
];
